import { Injectable } from '@angular/core';

@Injectable()
export class GzNotificationsService {
  constructor() {

  }

  public bare(title: string, content: string, override?: any) {
    return this.create(title, content, 'bare', override);
  }

  public error(title: string, content: string, override?: any) {
    return this.create(title, content, 'error', override);
  }

  public alert(title: string, content: string, override?: any) {
    return this.create(title, content, 'alert', override);
  }

  public info(title: string, content: string, override?: any) {
    return this.create(title, content, 'info', override);
  }

  public success(title: string, content: string, override?: any) {
    return this.create(title, content, 'success', override);
  }

  public create(title: string, content: string, type: string, override?: any) {
    let html = '<div class="gz-notification-wrapper ' + type + '">' +
      '<span class="icon icon-' + type + '"></span>' +
      '<div class="n_title">' + title + '</div>' +
      '<div class="n_content">' + content + '</div>' +
      '</div>';
    return html;
  }
}
